import Rails from "@rails/ujs"
import '../SplitView'
import '../stylesheets/admin'; // This file will contain admin custom CSS

/* For AdminLTE 3 */
import 'admin-lte/dist/js/adminlte.min'
import 'moment/moment'
import 'moment/locale/ja'
import 'bootstrap/dist/js/bootstrap.bundle.js'
import 'daterangepicker'
import 'bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js'
import bsCustomFileInput from 'bs-custom-file-input'
import 'summernote/dist/summernote-bs4.js'

import 'admin-lte/dist/css/adminlte.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'daterangepicker/daterangepicker.css'
import 'bootstrap-colorpicker/dist/css/bootstrap-colorpicker.min.css'
import 'summernote/dist/summernote-bs4.css'
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/regular.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'cocoon'
import jquery from 'jquery'
import 'select2'
import '../admin_user'

import '../datetimepicker'
import '../summernote'
import '../colorpicker'
import '../bs_custom_file_input'

import '../admin/users'
import '../call_center_user'
import '../callcenter_log'
/* For AdminLTE 3 */

Rails.start()
window.bsCustomFileInput = bsCustomFileInput
window.$ = window.jQuery = jquery
